/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface BranchRenewalRequestDto {
  status: BranchRenewalRequestDto.StatusEnum;
  /**
   * 2021-10-01
   */
  contractStartDate: string;
  /**
   * 2021-10-01
   */
  contractEndDate: string;
  documentUrl: string;
  remark: string;
}
// tslint:disable-next-line:no-namespace
export namespace BranchRenewalRequestDto {
  export type StatusEnum = 'pending' | 'in_progress' | 'completed';
  export const StatusEnum = {
      Pending: 'pending' as StatusEnum,
      InProgress: 'in_progress' as StatusEnum,
      Completed: 'completed' as StatusEnum,
  };
}
